<template>
<div class="pa-4 ListAll">
     
    <div v-if="items">
       
 

                <v-card v-for="item in  items" :key="item.register_id" class="mx-auto mt-5" tile >

                    <v-list-item six-line   style="background-color:#e7f5ff;">
                        <v-list-item-content>
                            <v-list-item-title style="font-size:1.2rem;" class="mb-2">{{item.fullname}}</v-list-item-title>
                            <v-list-item-subtitle class="mb-3"><b>งบประมาณ : </b> {{item.budget}}</v-list-item-subtitle>

                            <v-list-item-subtitle class="mb-3"><b>วันที่ :</b> {{item.created}} <b>โทร :</b> {{item.phone}} <b>อีเมล์ :</b> {{item.email}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="mb-3">
                                <div class="mb-3">{{item.title}}</div>

                                <div><b>CODE :</b> {{item.code}}</div>

                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="mb-3">
                                <span v-if="item.for_sale=='A'"><b>ขาย :</b> {{item.price}}</span>
                                <span v-if="item.for_rent=='A'" class="ml-4"><b>ให้เช่า :</b> {{item.price_rent}}</span>
                            </v-list-item-subtitle>

                            <v-list-item-subtitle class="mb-3">
                                <div class="row">
                                    <div class="col-sm-6">   {{item.status_title}}   
                                        <span v-if="item.c_status==6">{{item.date_6}}</span>
                                <span v-if="item.c_status==7">{{item.date_7}}</span>
                                <span v-if="item.c_status==8">{{item.date_8}}</span>
                                <span v-if="item.c_status==9">{{item.date_9}}</span></div>
                                <div class="col-sm-6 text-right" > <RegisterDetail   :register_id="item.register_id"  @updateItem="getItems()" /></div>
                                </div>
                             
                              
                            </v-list-item-subtitle>

                        </v-list-item-content>
                    </v-list-item>

                </v-card>

    
 
    </div>

     <div v-if="totalItemsCount==0" class="noList"> ไม่มีรายการค่ะ</div>
    <Paginator v-if="totalItemsCount>per_page" :rows="per_page" :totalRecords="totalItemsCount" @page="onPage($event)"></Paginator>
   
</div>
</template>

<script>
import RegisterDetail from '@/views/Register/RegisterDetail'
export default {

    components: {
        RegisterDetail
    },
    props: {
        propType: null
    },

    data: () => ({
        totalItemsCount:0,
        per_page:1,
        loading: null,
        open: false,
        register_id: null,

 
        items: null,
        itemStatus: 'all',
        status_list: null,
     

    }),
 

    watch: {

    },
    methods: {

    

        getItems() {
            let url = "register/list?page=" + this.page ;
            console.log(url)

            this.loading = true

            let $vm = this;
            this.$http
                .post(url, this.formData())
                .then(function (res) {
                  
                        $vm.items =  res.data.items 
                            $vm.totalItemsCount = res.data.total

               

                    $vm.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
           onPage(event) {

            this.page = event.page + 1
            this.getItems()
        },

    },
    created() {
        this.getItems()

    },
};
</script>
